interface Props {
  isNew?: boolean;
  isNewLabel?: string;
}

export function IsNewBadge({ isNew = false, isNewLabel = 'New' }: Props) {
  if (!isNew) return null;
  return (
    <span className="typography-button-sm rounded-full bg-[#A5F3E1] px-2 py-[2px] text-on-supplementary">
      {isNewLabel}
    </span>
  );
}
